<template lang="pug">
UpsertPage(
  title="Advanced Settings"
  @save="save()"
  @cancel="$emit('cancel')"
  :pending="pending"
  :canSubmit="userCanAddEditAdvancedSettings"
  hideCancel
  :showAuditTrail="canViewAuditTrail"
  objectType="BusinessUnit",
  :objectKey="businessUnitKey"
  )
  AdvancedSettingsPanels(:settings="settings" :disabled="pending" :hideToggleAndKeepPanelsExpanded="false")
</template>

<script>
import { mapGetters } from 'vuex'
import AdvancedSettingsPanels from '@v/settings/application/advanced/AdvancedSettingsPanels.vue'
import UpsertPage from '@v/components/UpsertPage.vue'
import Permission from '@v/models/UserPermissionEnum.js'

export default {
  components: { UpsertPage, AdvancedSettingsPanels },
  props: {
    settings: Array,
    pending: Boolean,
    businessUnitKey: String,
    canViewAuditTrail: Boolean,
  },
  data() {
    return {
      formErrors: {},
      formHasError: false,
    }
  },
  computed: {
    ...mapGetters('briqState', ['userHasPermission']),
    userCanAddEditAdvancedSettings() {
      return this.userHasPermission(Permission.API_Admin_Settings_Write)
    },
  },
  methods: {
    canSave() {
      let formHasError = false

      Object.keys(this.formErrors).forEach(key => {
        if (this.formErrors[key] === true) {
          formHasError = true
        }
      })

      this.formHasError = formHasError
    },
    save() {
      if (!this.formHasError) this.$emit('save')
      else this.$notifyError('Please fix the form erros')
    },
  },
  created() {
    this.$bus.$on('updateFormErrors', item => {
      this.formErrors[item.settingKey] = item.error

      this.canSave()
    })
  },
}
</script>
